import React, { useRef, useState } from 'react';
import {
  Wrap,
  StyledSlider,
  SliderItem,
  PageView,
  UserInfo,
  Content,
  Buttons,
  ReportButton,
  DeleteButton
} from './styled';
import useModalStore from '../../../../../hooks/useModalStore';
import { NamedCommunityService } from 'services/named';
import Url from 'environment';
import userProfileDef from 'images/sports/common/user-profile-def.png';
import useUsersStore from '../../../../../hooks/useUsersStore';

import { observer } from 'mobx-react';

const PowerChatCarousel = observer(
  ({
    powerChat,
    viewChat,
    setViewChat,
    changeCurrentSlide,
    deletePowerChat
  }) => {
    const modalStore = useModalStore();
    const [currentSlide, setCurrentSlide] = useState(1);
    const sliderRef = useRef(null);
    const [swiping, setSwiping] = useState(false);
    const userStore = useUsersStore();

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      beforeChange: (oldIndex, newIndex) => {
        setCurrentSlide(newIndex + 1);
        changeCurrentSlide(newIndex);
      }
    };

    const handleMouseDown = (event) => {
      event.preventDefault();
    };

    const handleMouseUp = () => {
      setSwiping(sliderRef.current.innerSlider.state.swiping);
    };

    const onClickReport = (chat) => {
      if (userStore.data.id === null) {
        modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
        return;
      }

      if (window.confirm(`신고를 접수하시겠습니까?`)) {
        NamedCommunityService.report({
          category: 'cheer',
          relId: chat.id,
          relTable: '@cheer',
          targetId: chat.user_id
        }).then((res) => {
          if (res.code === 200) {
            alert('신고가 접수되었습니다.');
          } else {
            alert(res.message);
          }
        });
      }
    };

    const onClickDelete = (chat, index) => {
      if (confirm('삭제 하시겠습니까?')) {
        deletePowerChat(chat, index);
      }
    };

    return (
      <Wrap view={viewChat} onClick={() => setViewChat(false)}>
        <StyledSlider ref={sliderRef} {...settings}>
          {powerChat.comments.map((item, key) => {
            return (
              <div
                key={key}
                onMouseDownCapture={handleMouseDown}
                onMouseUpCapture={handleMouseUp}
              >
                <ChatItem
                  item={item}
                  currentSlide={currentSlide}
                  totalCount={powerChat.totalCount}
                  setViewChat={setViewChat}
                  viewChat={viewChat}
                  swiping={swiping}
                />
                {viewChat && (
                  <Buttons>
                    <ReportButton
                      onClick={(e) => {
                        e.stopPropagation();
                        onClickReport(item);
                      }}
                    >
                      신고하기
                    </ReportButton>
                    {userStore.data.id === item.user_id && (
                      <DeleteButton
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickDelete(item, key);
                        }}
                      >
                        삭제하기
                      </DeleteButton>
                    )}
                  </Buttons>
                )}
              </div>
            );
          })}
        </StyledSlider>
      </Wrap>
    );
  }
);

const ChatItem = ({
  item,
  currentSlide,
  totalCount,
  setViewChat,
  viewChat,
  swiping
}) => {
  const onClickCopy = (event) => {
    event.stopPropagation();
    event.currentTarget.select();
    document.execCommand('Copy');
    alert('클립보드에 복사되었습니다');
  };

  const contentFormat = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, key) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={key}
            href={part}
            target="_blank"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <span>{part}</span>
            {/*{part}*/}
          </a>
        );
      }

      if (part.match(/\[[A-Za-z0-9]+\]/g)) {
        return part.split(/(\[[A-Za-z0-9]+\])/g).map((subPart, key) => {
          if (subPart.includes('[')) {
            return (
              <label key={key}>
                {subPart.substr(1, subPart.length - 2)}
                <input
                  type={'text'}
                  readOnly={true}
                  onClick={onClickCopy}
                  value={subPart.substr(1, subPart.length - 2)}
                />
              </label>
            );
          }
          return subPart;
        });
      }

      return part;
    });
  };

  return (
    <SliderItem
      view={viewChat}
      onClick={(e) => {
        e.stopPropagation();
        if (!swiping) {
          setViewChat(true);
        }
      }}
    >
      <PageView>{`${currentSlide} / ${totalCount}`}</PageView>
      <UserInfo>
        <img
          src={
            item.profile_image_path
              ? `${Url.thumbCrop}/112x112${item.profile_image_path.replace(
                  'data/',
                  ''
                )}`
              : userProfileDef
          }
          onError={(event) => {
            event.target.src = userProfileDef;
          }}
        />
        <span>{item.mb_nick}</span>
      </UserInfo>
      <Content viewChat={viewChat}>{contentFormat(item.content)}</Content>
    </SliderItem>
  );
};

export default PowerChatCarousel;
